import { AbstractControl } from '@angular/forms';
import { GenericObjectModel } from '@tcp/cloudia-utilities';
import { Observable, ReplaySubject } from 'rxjs';

declare module '@angular/forms' {
  interface AbstractControl {
    meta: GenericObjectModel[];
    meta$: ReplaySubject<GenericObjectModel[]>;
    metaOb$: Observable<GenericObjectModel[]>;
  }
}
AbstractControl.prototype.meta = [];
